import { DocumentReference, Timestamp, doc } from "firebase/firestore";
import { db } from "../firebase";

export const minTrue = (...values: number[]) => {
  return Math.min(...values.filter((value) => value > 0));
};

export const minTimestamp = (...values: Timestamp[]) => {
  let min: Timestamp | undefined;
  values.forEach((value) => {
    if (value && (!min || value < min)) {
      min = value;
    }
  });
  return min;
};

export const setUrlParam = (name: string, value?: string) => {
  const newSearch = new URLSearchParams(location.search);
  if (value) {
    newSearch.set(name, value);
  } else {
    newSearch.delete(name);
  }
  history.pushState(
    null,
    "",
    location.origin + location.pathname + "?" + newSearch.toString()
  );
};

export const filterRecord = <T>(
  records: Record<string, T>,
  pred: (record: [string, T]) => boolean
) => {
  return Object.fromEntries(Object.entries(records).filter(pred));
};

export const castDoc = <T>(path: string, ...pathSegments: string[]) => {
  return doc(db, path, ...pathSegments) as DocumentReference<T>;
};

export const partition = <T>(
  arr: T[],
  fn: (val: T, i?: number, arr?: T[]) => boolean
) =>
  arr.reduce(
    (acc, val, i, arr) => {
      acc[fn(val, i, arr) ? 0 : 1].push(val);
      return acc;
    },
    [[] as T[], [] as T[]]
  );

export const titleCaps = (title: string) => {
  const small =
    "(a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|v[.]?|via|vs[.]?|with)";
  const punct = "([!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)";

  const lower = (word: string) => word.toLowerCase();
  const upper = (word: string) =>
    word.substring(0, 1).toUpperCase() + word.substring(1);

  const parts = [];
  const split = /[:.;?!] |(?: |^)["Ò]/g;
  let index = 0;

  while (true) {
    const m = split.exec(title);

    parts.push(
      title
        .substring(index, m ? m.index : title.length)
        .replace(/\b([A-Za-z][a-z.'Õ]*)\b/g, function (all) {
          return /[A-Za-z]\.[A-Za-z]/.test(all) ? all : upper(all);
        })
        .replace(RegExp("\\b" + small + "\\b", "ig"), lower)
        .replace(
          RegExp("^" + punct + small + "\\b", "ig"),
          function (_all, punct, word) {
            return punct + upper(word);
          }
        )
        .replace(RegExp("\\b" + small + punct + "$", "ig"), upper)
    );

    index = split.lastIndex;

    if (m) parts.push(m[0]);
    else break;
  }

  return parts.join("").replace(/ V(s?)\. /gi, " v$1. ");
};

export const urlSource = (url: string) => {
  if (url.indexOf("spotify.com") >= 0) return "Spotify";
  if (url.indexOf("facebook.com") >= 0) return "Facebook";
  return "";
};
